module.exports = __webpack_public_path__ + "static/media/yellow_temp.74af875c.svg";